module.exports = __webpack_public_path__ + "fonts/fa-regular-400.a3d7d331.woff2";